import pushToDataLayer from '@logic/data-layers/pushToDataLayer'

export const pushContactFormInfoDataLayer = (reason?: string, case_ref?: string) => {
  pushToDataLayer({
    event: 'interaction',
    event_name: 'form_submitted',
    form_name: 'contact',
    reason,
    case_ref
  })
}
